import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import EntityCard from "@/components/EntityCard";
import { Skeleton } from "@/components/ui/skeleton";

const LABELS = { dham: "Dhams", temple: "Temples", yatra: "Yatras", hotel: "Hotels", dharamshala: "Dharamshalas", package: "Packages" };

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!q) return;
    setData(null);
    api.get("/entities/search", { params: { q } }).then(r => setData(r.data));
  }, [q]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-gold-dark">Search</div>
        <h1 data-testid="search-heading" className="font-display text-3xl font-bold text-indigo-deep">Results for "{q}"</h1>
      </div>
      {!data ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{["s1", "s2", "s3", "s4", "s5", "s6"].map((k) => <Skeleton key={k} className="h-80 rounded-xl" />)}</div>
      ) : data.total === 0 ? (
        <div className="text-center py-16 text-indigo-deep/60">No matches. Try broader terms like "Kedarnath", "helicopter", "Varanasi".</div>
      ) : (
        Object.entries(data.grouped).map(([type, items]) => (
          <section key={type} className="mb-10">
            <h2 className="font-display text-xl text-indigo-deep mb-4">{LABELS[type] || type} <span className="text-sm text-indigo-deep/50">({items.length})</span></h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{items.map(e => <EntityCard key={e.id} e={e} />)}</div>
          </section>
        ))
      )}
    </div>
  );
}
